import React from "react";
import Hero from "./sections/Hero";
import CTASection from "./sections/CTASection";
import FeaturedServices from "./sections/FeaturedServices";
import PopularRequest from "./sections/PopularRequests";
import HowItWorks from "./sections/HowItWorks";
import TrustSection from "./sections/TrustSection";
import Testimonials from "./sections/Testimonials";

function Home() {
    return (
        <div>
            <Hero/>
            <FeaturedServices/>
            <PopularRequest/>
            <HowItWorks/>
            <TrustSection/>
            <Testimonials/>
            <CTASection/>
        </div>
    );
}

export default Home